module.exports = __webpack_public_path__ + "media/images/innew-d27f6af9c090bae1d3abc84e451f086b.png";